/**
 * Take efectivo para un fetch que resetea a página 1 (`cursor: ''`).
 * El take negativo del cursor solo es válido en paginación backward (con
 * cursor pivote); un fetch de primera página con take<0 haría que el servidor
 * (Prisma) devolviera la COLA del dataset. Siempre positivo.
 */
export function firstPageTake(take: number | undefined, fallback: number): number {
  return Math.abs(take ?? fallback);
}
